import { render, staticRenderFns } from "./banks-modal.vue?vue&type=template&id=336f898a&"
import script from "./banks-modal.vue?vue&type=script&lang=js&"
export * from "./banks-modal.vue?vue&type=script&lang=js&"
import style0 from "./banks-modal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports